import api from '@/api/api.coffee'

# module-level translateRequest promise cache, shared by every component instance.
# It prevents re-requesting the same translation in multiple components.
translationCache = new Map()
translationCacheSize = 5000

export default  
  created: ->
    return unless (this != @$root); # guard against running this in the root component.
    return unless (@$store); # guard against components that don't use vuex.
    @translateFields()
  methods:
    translate: (source) ->        
      console.log('translate in', source) if @dev     
      return '' unless source 
      # return source if there is no sourcelanguage
      sourceLanguage = @sourceLanguage
      console.log('sourceLanguage', sourceLanguage) if @dev      
      return source unless sourceLanguage
      # return source if there is no language
      destinationLanguage = @destinationLanguage      
      console.log('destinationLanguage', destinationLanguage) if @dev
      return source unless destinationLanguage
      # return source if there is no difference, nothing to do here.
      console.log('matching', sourceLanguage == destinationLanguage) if @dev            
      return source unless sourceLanguage != destinationLanguage
      cacheKey = "#{sourceLanguage}|#{destinationLanguage}|#{source}"                
      unless translationCache.has(cacheKey)
        if translationCache.size >= translationCacheSize
          translationCache.delete(translationCache.keys().next().value)
        translationCache.set(cacheKey, @translateRequest(sourceLanguage, destinationLanguage, source))
      try
        result = await translationCache.get(cacheKey)
      catch err
        translationCache.delete(cacheKey)
        result = source
      # component died while translating — never settle, so vue-async-computed's $set never fires
      result = await new Promise(->) if @_isDestroyed or @_isBeingDestroyed
      # if the fetch fell back to source, evict so it can retry later
      translationCache.delete(cacheKey) if result == source
      console.log('translate out', result) if @dev
      return result
    translateRequest: (sourceLanguage, destinationLanguage, source) ->
      # get the translation from the server.
      request = { sourceLanguage: sourceLanguage, destinationLanguage: destinationLanguage, source: source }
      response = await api.translate().details(request)    
      translation = response?.data?.result?.translation
      return translation if translation?.length > 0
      # If there was no translation, try asap-create.      
      if response?.data?.error
        request = { sourceLanguage: sourceLanguage, destinationLanguage: destinationLanguage, source: source, asap: true }
        response = await api.translate().create(request)
        return source if response?.data?.error
        translation = response?.data?.result?.translation        
        return translation if translation?.length > 0
      # If there was no translation at all, return source
      return source
    translateFields: ->     
      for key, value of @translatedFields        
        this[value] = await @translate(this[value])
    translateObjectKeys: (source, keys) ->
      if Array.isArray source
        return await Promise.all source.map (subsource) => @translateObjectKeys subsource, keys
      out = Object.assign {}, source
      for key in keys when source[key]?        
        out[key] = await @translate source[key]
      out 
  watch:
    destinationLanguage: (newval, oldval) ->      
      @translateFields()
  computed:        
    sourceLanguage: -> @$store.getters.sourceLanguage
    destinationLanguage: -> @$store.getters.destinationLanguage
    dev: -> false
